import React, { useEffect, useRef, useState } from "react";
import { FaPlus } from "react-icons/fa";
import "./Attachments.scss";
import { ErrorToast, SuccessToast, WarningToast } from "../../../Components/ToastComponent/RectHotToast";
import axios from "axios";
import { useMutation } from "@apollo/client";
import { Add_Files_To_Task, Delete_Fiels_To_Task } from "../utils/quires";
import pdfIcon from "../utils/Pdf.png";
import xlIcon from "../utils/xlsx.png";
import FileViewer from "./FileViewer";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import styled from "styled-components";
import { FaDownload } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
const Attachments = ({ attachments, TaskId, handleOpen }) => {
  const [images, setImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [makeapicall, setMakeapicall] = useState(false);
  const uploadRef = useRef(null);
  // eslint-disable-next-line
  const [copySharedLink, setCopySharedLink] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [AddFilesTask] = useMutation(Add_Files_To_Task, {
    onCompleted: () => {
      SuccessToast("File Uploaded Successfully!");
    },
    onError: (err) => {
      ErrorToast(`${err.message}`);
    },
  });
  const [Delete_FileInTask] = useMutation(Delete_Fiels_To_Task, {
    onCompleted: () => {
      SuccessToast("File Deleted Successfully!");
    },
    onError: (err) => {
      ErrorToast(`${err.message}`);
    },
  });
  const handleDownload = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileUrl.split("/").pop(); // Extracts file name from URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDelete = async (fileUrl) => {
    const updatedata = images.filter((ele) => ele !== fileUrl);
    await Delete_FileInTask({
      variables: {
        TaskID: TaskId,
        file: fileUrl,
      },
    });
    setImages(updatedata);
    setIsViewerOpen(false);
  };
  useEffect(() => {
    if (uploadedImage !== null && makeapicall) {
      AddFilesTask({
        variables: {
          addFilesToTaskId: TaskId,
          file: uploadedImage,
        },
      });
      setMakeapicall(false);
      setImages([...images, uploadedImage]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedImage, makeapicall]);
  useEffect(() => {
    handleOpen(isViewerOpen);
  }, [isViewerOpen]);

  const uploadFileToBackend = async (fileBlob, setCopySharedLink) => {
    if (!fileBlob) {
      WarningToast("No file selected to upload");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileBlob, fileBlob.name);
    let temp = window.location.pathname;
    let temp2 = temp.split("/");

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/upload/single`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          path: temp2[1],
        },
      });

      if (data?.status) {
        setCopySharedLink(data?.fileURL);
        setMakeapicall(true);
        setUploadedImage(data?.fileURL);
      }
    } catch (error) {
      ErrorToast("Failed to upload", error);
    }
  };

  useEffect(() => {
    setImages(attachments);
  }, [attachments]);

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setIsViewerOpen(true);
  };

  const handlePlusClick = () => {
    if (uploadRef.current) {
      uploadRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      WarningToast("No file selected to upload");
      return;
    }

    // Check file size, let's assume the limit is 5MB
    if (file.size > 5 * 1024 * 1024) {
      WarningToast("File size should not exceed 5MB");
      return;
    }

    // Check file type
    const validTypes = ["pdf", "png", "jpg", "jpeg", "xlsx"];
    const fileType = file.name.split(".").pop().toLowerCase();
    if (!validTypes.includes(fileType)) {
      WarningToast("Unsupported file type");
      return;
    }

    await uploadFileToBackend(file, setCopySharedLink);
  };

  const renderAttachment = (file) => {
    const fileExtension = file.split(".").pop();
    const isPdf = fileExtension === "pdf";
    const isxls = fileExtension === "xlsx";

    function renderfile() {
      if (isPdf) {
        return pdfIcon;
      } else if (isxls) {
        return xlIcon;
      } else {
        return file;
      }
    }
    return <img src={renderfile()} alt="attachment" onClick={() => handleFileClick(file)} />;
  };

  return (
    <div className="attachment-container">
      <div className="attachment-header">
        <div className="header-text">
          <span>Attachments</span> <span className="span-cont">{images?.length ? images?.length : 0}</span>
        </div>
        <div onClick={handlePlusClick} className="upload-button">
          <FaPlus />
        </div>
      </div>
      <input type="file" ref={uploadRef} style={{ display: "none" }} onChange={handleFileChange} />
      <div className="attachment-grid">
        {images?.map((file, index) => (
          <ImageContainer key={index} className="attachment-item">
            {renderAttachment(file)}
          </ImageContainer>
        ))}
      </div>
      {/* <FileViewer fileUrl="https://aws-emt.s3.amazonaws.com/StatusBoard/cb8162f1-c1c4-40b0-9da8-9e8c5b3d52bb-document.pdf" /> */}
      {isViewerOpen ? (
        <>
          <Reactportal
            open={isViewerOpen}
            onClose={() => {
              setIsViewerOpen(false);
            }}
            TypeOfPortal={"File view"}
          >
            <Container>
              <div className="user-options">
                <div className="icon-wrapper" onClick={() => handleDownload(selectedFile)}>
                  <FaDownload />
                </div>
                <div
                  className="icon-wrapper"
                  onClick={() => {
                    handleDelete(selectedFile);
                  }}
                >
                  <MdDelete />
                </div>
              </div>
              <FileViewer fileUrl={selectedFile} />
            </Container>
          </Reactportal>
        </>
      ) : null}
    </div>
  );
};

export default Attachments;
const Container = styled.div`
  max-height: 60vh;
  width: 50vw;
  background-color: #f9f9f9; // Light grey background for the viewer area
  padding: 20px; // Uniform padding around the content
  border-radius: 8px; // Rounded corners
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); // Subtle shadow
  overflow: auto;
  overflow-y: scroll;
  .file-viewer {
    /* border: 1px solid red; */
    width: 100%; // Adjust width to account for padding
    height: 100%;
    margin: auto; // Centering the content horizontally
    margin-top: 20px;
    /* display: flex; */
    /* overflow: auto; */
    // Centers content vertically in the flex container
    display: flex;
    align-items: center;
    justify-content: center;
    .image-container {
      /* display: flex;
      align-items: center;
      justify-content: center; */
      width: auto;
      height: auto;
    }
    .react-pdf__Page__canvas {
      flex-shrink: 0; // Prevents the canvas from shrinking
      width: auto; // Ensures the canvas width is determined by the content
      height: auto; // Ensures the canvas height is determined by the content
    }
  }
  .file-viewer table {
    width: 100%; // Ensures tables use the full width of the viewer
    border-collapse: collapse; // Improves border handling
    // Adds some spacing above the table
    /* overflow: auto; */
    overflow-x: scroll;
  }

  .file-viewer th,
  .file-viewer td {
    border: 1px solid #ccc; // Adds borders to cells
    padding: 5px; // Pads the cell content
    text-align: left; // Aligns text to the left
  }

  .file-viewer th {
    background-color: #f2f2f2; // Light grey background for header cells
  }
  .user-options {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;

    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background-color: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;

      &:hover {
        background-color: #ececec;
      }

      svg {
        color: #333;
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const ImageContainer = styled.div`
  width: 100px; // Fixed width for each image
  height: 100px; // Fixed height for each image
  border-radius: 8px; // Rounded corners for images
  overflow: hidden; // Ensures the image doesn't escape its container
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover; // Ensures the image covers the container fully
  }
`;
